// CommonJS : source unique partagée par le front (import) et par server2.js (require).

function parseVersion(ver) {
  if (!ver) return null;
  const raw = String(ver).trim().replace(/^v/i, "");
  const [numPart, prePart] = raw.split(/-(.+)/);
  const nums = numPart.split(".").map((n) => parseInt(n, 10) || 0);
  return { parts: nums, prerelease: prePart || null, raw };
}

function compareVersions(aStr, bStr) {
  const a = parseVersion(aStr);
  const b = parseVersion(bStr);
  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const maxLen = Math.max(a.parts.length, b.parts.length, 3); // au moins 3 segments
  for (let i = 0; i < maxLen; i++) {
    const na = a.parts[i] || 0;
    const nb = b.parts[i] || 0;
    if (na > nb) return 1;
    if (na < nb) return -1;
  }

  if (a.prerelease && !b.prerelease) return -1;
  if (!a.prerelease && b.prerelease) return 1;
  if (a.prerelease && b.prerelease) {
    if (a.prerelease > b.prerelease) return 1;
    if (a.prerelease < b.prerelease) return -1;
  }
  return 0;
}

module.exports = { parseVersion, compareVersions };
